<script setup lang="ts">
import { meInfo } from '@/services/mentor/Mentor'
import { onMounted } from 'vue'
import { useUserStore } from '@/stores/user'
import BaykusAvatar from '@/components/BaykusAvatar/BaykusAvatar.vue'
import BaykusDropDown from '@/components/CompositeComponents/BaykusDropDown/BaykusDropDown.vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const navItems = [
  {
    name: 'To-Do List',
    path: '/mentor/app/dashboard'
  },
  {
    name: 'Öğrencilerim',
    path: '/mentor/app/students'
  },
  {
    name: 'Sınavlar',
    path: '/mentor/app/sinavlar'
  },
  {
    name: 'Randevularım',
    path: '/mentor/app/appointments',
    isHidden: false
  }
]
const { SET_USER_DATA, getUserData } = useUserStore()
const getMeInfo = async () => {
  try {
    const response = await meInfo()
    SET_USER_DATA(response.data)
  } catch (e) {
    console.log(e)
  }
}
const logout = () => {
  localStorage.clear()
  router.push('/auth/login')
}
onMounted(() => {
  getMeInfo()
})
</script>

<template>
  <header class="mentor-header sticky top-0 shadow-sm z-10 px-4 xl:px-0">
    <div class="container mx-auto">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <RouterLink to="/">
            <div class="w-[47px] h-[32px]">
              <img src="/images/logo.png" alt="Logo" />
            </div>
          </RouterLink>
          <ul class="flex gap-[12px] lg:gap-[32px] ml-[50px]">
            <template v-for="(item, index) in navItems" :key="index">
              <li v-if="!item.isHidden">
                <RouterLink class="nav-link" :to="item.path">
                  {{ item.name }}
                </RouterLink>
              </li>
            </template>
          </ul>
        </div>

        <BaykusDropDown mode="click">
          <template #trigger>
            <div class="user-info flex items-center cursor-pointer">
              <p class="text-base font-medium text-gray-700">
                {{ getUserData.name }} {{ getUserData.surname }}
              </p>
              <BaykusAvatar
                :user-name="getUserData.name"
                :user-surname="getUserData.surname"
                :src="getUserData.profilePhotoUrl"
                width="40"
                class="ml-4"
                height="40"
              />
            </div>
          </template>
          <template #body>
            <div class="flex py-4 px-4 flex-col gap-3 items-center justify-center">
              <router-link
                class="block w-full text-center pb-2 border-b border-b-gray-200"
                :to="{ name: 'mentor.app.profile' }"
              >
                Profilim
              </router-link>

              <a @click.prevent="logout" href="#">Çıkış Yap</a>
            </div>
          </template>
        </BaykusDropDown>
      </div>
    </div>
  </header>
</template>

<style lang="scss">
.mentor-header {
  @apply bg-gray-50 py-4;
}
</style>
